import { render, staticRenderFns } from "./FAccountPackage.vue?vue&type=template&id=2a19e648&"
import script from "./FAccountPackage.vue?vue&type=script&lang=js&"
export * from "./FAccountPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports